<template>
  <v-card-text>
    <div layout="row">
      <div
        v-if="field.field.type != Consts.FIELD_TYPES.SEPARATOR"
        layout="column"
        flex="40"
      >
        <strong>{{ field.field.name }}</strong>
      </div>
      <div
        v-else
        layout="column"
        class="flex pl-1 pr-1"
      >
        <em>{{ field.field.name }}</em>
      </div>
      <div
        v-if="field.field.type != Consts.FIELD_TYPES.SEPARATOR"
        layout="column"
        class="ml-4"
        flex
      >
        <template v-if="field.field.type == Consts.FIELD_TYPES.SIMPLE_TEXT">
          {{ field.simple_text_value }}
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.LONG_TEXT">
          <div class="nl2br">
            {{ field.long_text_value }}
          </div>
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.DATE">
          {{ americanizeDate(field.date_value) }}
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.EMAIL">
          {{ field.simple_text_value }}
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.NUMBER">
          {{ field.number_value }}
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.SINGLE_CHOICE">
          {{ field.single_choice_value }}
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.MULTIPLE_CHOICES">
          {{ multiChoiceValues }}
        </template>
        <template v-if="field.field.type == Consts.FIELD_TYPES.RADIO_GROUP">
          <div class="select-container">
            <div class="select-box">
              <div
                v-if="field.field.options.length > 0"
                class="radio-group-container"
              >
                <v-radio-group
                  v-model.lazy="field[Consts.EVAL_TARGETS[field.targeted_col]]"
                  row
                  :readonly="true"
                  :hide-details="true"
                >
                  <v-radio
                    v-for="item in field.field.options"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                    color="primary"
                  />
                </v-radio-group>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </v-card-text>
</template>
<script>
  import Consts from "@/consts"
  import moment from 'moment'

  export default {
    props: {
      field: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        Consts,
      }
    },
    computed: {
      multiChoiceValues() {
        if(this.field.field.type == Consts.FIELD_TYPES.MULTIPLE_CHOICES) {
          return this.field.options.reduce((acc, o, index) => {
            return acc + o.choice_value + (index == this.field.options.length - 1 ? "" : ", ")
          }, "")
        }
        return ""
      }
    },
    methods: {
      americanizeDate(date) {
        if (!date) return null;

        if (date.indexOf(".") >= 0) {
          return date;
        }

        return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
      }
    }
  }
</script>

<style scoped lang="sass">
  .v-input--selection-controls
    margin-top: 0px !important
  .v-card__text
    padding: 5px 16px
</style>
